var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof PaymentForms !== "undefined") return resolve();
	__webpack_require__.l("https://paymentformsuiv2.cashfree.com/remoteEntry.js?&version=1790052167019", (event) => {
		if(typeof PaymentForms !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "PaymentForms");
}).then(() => (PaymentForms));